import { EventDispatcherSources } from '../events';
import type { AIEventsInstrumentationConfig } from './AIEventsInstrumentationContext';

export const defaultAIEventsInstrumentationConfigValues: Pick<
	AIEventsInstrumentationConfig,
	| 'actionSubjectId'
	| 'isAIFeature'
	| 'eventDispatcherSource'
	| 'skipAISessionValidation'
	| 'useDefaultGASv3EventSchema'
	| 'enablePlatformEvents'
> = {
	isAIFeature: 1,
	actionSubjectId: 'client',
	eventDispatcherSource: EventDispatcherSources.JSLib,
	skipAISessionValidation: false,
	useDefaultGASv3EventSchema: false,
	enablePlatformEvents: false,
};
